import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConfirmModal } from '../../ui';
import sessionsService from '../../../services/sessionsServices';
import Toast from '../../Toast';
import { TemporaryChatContext } from '../../../Context/temporaryChatContext';
import { AuthContext } from '../../../Context/authContext';
import { useContextHook } from 'use-context-hook';
import { DEFAULT_PEPPER_ID } from '../../ChatSection/PolyChatHeader';
import { sessionsInvalidateKey } from '../../../hooks';

/**
 * Delete Chat confirm modal.
 * API unchanged: sessionsService.deleteSession
 */
const DeleteChatModal = ({ onClose, data }) => {
  const queryClient = useQueryClient();
  const { selectedAgent } = useContext(TemporaryChatContext);
  const { user } = useContextHook(AuthContext, v => ({ user: v.user }));

  const handleSubmit = useMutation({
    mutationFn: async () => {
      return await sessionsService?.deleteSession({
        platform_id: 'plateslabs',
        session_id: data?.id,
        user_id: user?.data?.ID,
        agent_id: selectedAgent?.value || DEFAULT_PEPPER_ID,
        project_id: 'test',
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      onClose();
      queryClient.invalidateQueries({ queryKey: sessionsInvalidateKey });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <ConfirmModal
      title="Delete Chat"
      message={<p>Are you sure you want to delete this chat? There is no way to recover it.</p>}
      confirmLabel="Delete"
      busyLabel="Deleting..."
      loading={handleSubmit.isPending}
      onConfirm={() => handleSubmit.mutate()}
      onClose={onClose}
    />
  );
};

export default DeleteChatModal;
